<template>
  <article class="content-page">
    <h1 class="heading">ARTWORK</h1><br>

    <table border="0">
      <tr>
        <td align="center" valign="top">
          <img :src="require('@/assets/images/artwork/houserules_preview.jpg')">
        </td>
        <td valign="center">

          <p><strong>
            Retro "House Rules" sign.<br>
            Includes two variations of optional add-on bottom sections!
          </strong></p>

          <p class="smalltext">
            The wording here is authentic from the original signs.<br>
            The original signs were printed double-sided on hardboard, and measured 46" x 23" x 1/4" (for just the main sign).<br>
            The bottom sections were the same width and material and were hung underneath.
          </p>

          <p class="smalltext">
            Thanks to Brian Pipa for providing the measurements!
          </p>

          <p class="smalltext">
            <a href="/downloads/houserules.zip">Download House Rules signs (Adobe Illustrator .ai file - 1.18MB)</a><br>
            <strong>Author:</strong> Peter Hirschberg
          </p>

        </td>
      </tr>
      <tr>
        <td align="center" valign="top">
          <img :src="require('@/assets/images/artwork/timeout_high_score_cards_thumb.png')">
        </td>
        <td valign="center">

          <p><strong>
            Time-Out Tunnel "High Score of the Week" Cards<br>
            Back in the day at Time-Out, every arcade machine had one of these cards attached to it. Includes all 4 colors.
          </strong></p>

          <p>
            <a href="/downloads/timeout_high_score_cards.zip">Download Time-Out High Score Cards (Both vector & PNG versions - 291k)</a><br>
            <strong>Author:</strong> Peter Hirschberg
          </p>

        </td>
      </tr>
      <tr>
        <td align="center" valign="top">
          <img :src="require('@/assets/images/artwork/giftcoupons_preview.jpg')">
        </td>
        <td valign="center">

          <p><strong>
            Retro "Gift Coupons" sign.<br>
            The wording here is authentic from the original sign.
          </strong></p>

          <p>
            <a href="/downloads/giftcoupons.zip">Download Gift Coupons sign (Both vector & PNG versions - 428k)</a><br>
            <strong>Author:</strong> Peter Hirschberg
          </p>

        </td>
      </tr>
      <tr>
        <td align="center" valign="top">
          <img :src="require('@/assets/images/artwork/timeout_tunnel_logo_preview.jpg')">
        </td>
        <td valign="center">
          <p><strong>
            The Time-Out Tunnel Logo
          </strong></p>
          <p>
            <a href="/downloads/timeout_tunnel_logo.zip">Download Time-Out Tunnel Logo (Adobe Illustrator .ai file - 177k)</a><br>
            <strong>Author:</strong> Peter Hirschberg
          </p>
        </td>
      </tr>
      <tr>
        <td align="center" valign="top">
          <img :src="require('@/assets/images/artwork/trashcan_preview.jpg')">
        </td>
        <td valign="center">
          <p><strong>
            Retro Time-Out Trashcan Art<br>
            This was the artwork for the trashcans used in Time Out Arcade in the '80s. Would make a nifty poster as well.
          </strong></p>
          <p>
            <a href="/downloads/timeout_trashcan.zip">Download Time-Out Trashcan Art (Adobe Illustrator .ai file - 377k)</a><br>
            <strong>Author:</strong> Peter Hirschberg
          </p>
        </td>
      </tr>
    </table>

  </article>
</template>

<script>
export default {
  name: 'Downloads'
}
</script>

<style scoped lang="scss">
table {
  td {
    padding: 20px;
  }
}
</style>
